var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBar5(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 44,
    viewBox: "0 0 36 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer 8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M34.7742 4.96774H29.8065V4.25806C29.8065 4.06985 29.7317 3.88934 29.5986 3.75625C29.4655 3.62316 29.285 3.54839 29.0968 3.54839H28.3871C28.3871 1.59181 27.1139 0 25.5484 0C23.9828 0 22.7097 1.59181 22.7097 3.54839H22C21.8118 3.54839 21.6313 3.62316 21.4982 3.75625C21.3651 3.88934 21.2903 4.06985 21.2903 4.25806V4.96774H14.1935V4.25806C14.1935 4.06985 14.1188 3.88934 13.9857 3.75625C13.8526 3.62316 13.6721 3.54839 13.4839 3.54839H12.7742C12.7742 1.59181 11.501 0 9.93548 0C8.36994 0 7.09677 1.59181 7.09677 3.54839H6.3871C6.19888 3.54839 6.01837 3.62316 5.88528 3.75625C5.75219 3.88934 5.67742 4.06985 5.67742 4.25806V4.96774H0.709677C0.521459 4.96774 0.34095 5.04251 0.20786 5.1756C0.0747695 5.30869 0 5.4892 0 5.67742V43.2903C0 43.4785 0.0747695 43.659 0.20786 43.7921C0.34095 43.9252 0.521459 44 0.709677 44H34.7742C34.9624 44 35.1429 43.9252 35.276 43.7921C35.4091 43.659 35.4839 43.4785 35.4839 43.2903V5.67742C35.4839 5.4892 35.4091 5.30869 35.276 5.1756C35.1429 5.04251 34.9624 4.96774 34.7742 4.96774ZM25.5484 1.41935C26.3177 1.41935 26.9677 2.39445 26.9677 3.54839H24.129C24.129 2.39445 24.7791 1.41935 25.5484 1.41935ZM22.7097 4.96774H28.3871V9.22581H22.7097V4.96774ZM21.2903 6.3871V7.80645H14.1935V6.3871H21.2903ZM9.93548 1.41935C10.7048 1.41935 11.3548 2.39445 11.3548 3.54839H8.51613C8.51613 2.39445 9.16619 1.41935 9.93548 1.41935ZM7.09677 4.96774H12.7742V9.22581H7.09677V4.96774ZM13.4839 10.6452C13.6721 10.6452 13.8526 10.5704 13.9857 10.4373C14.1188 10.3042 14.1935 10.1237 14.1935 9.93548V9.22581H21.2903V9.93548C21.2903 10.1237 21.3651 10.3042 21.4982 10.4373C21.6313 10.5704 21.8118 10.6452 22 10.6452H29.0968C29.285 10.6452 29.4655 10.5704 29.5986 10.4373C29.7317 10.3042 29.8065 10.1237 29.8065 9.93548V9.22581H31.2258V39.7419H4.25806V9.22581H5.67742V9.93548C5.67742 10.1237 5.75219 10.3042 5.88528 10.4373C6.01837 10.5704 6.19888 10.6452 6.3871 10.6452H13.4839ZM34.0645 42.5806H1.41935V6.3871H5.67742V7.80645H3.54839C3.36017 7.80645 3.17966 7.88122 3.04657 8.01431C2.91348 8.1474 2.83871 8.32791 2.83871 8.51613V40.4516C2.83871 40.6398 2.91348 40.8203 3.04657 40.9534C3.17966 41.0865 3.36017 41.1613 3.54839 41.1613H31.9355C32.1237 41.1613 32.3042 41.0865 32.4373 40.9534C32.5704 40.8203 32.6452 40.6398 32.6452 40.4516V8.51613C32.6452 8.32791 32.5704 8.1474 32.4373 8.01431C32.3042 7.88122 32.1237 7.80645 31.9355 7.80645H29.8065V6.3871H34.0645V42.5806Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M7.30461 16.1137C7.43769 16.2467 7.61817 16.3215 7.80635 16.3215C7.99453 16.3215 8.17501 16.2467 8.30809 16.1137L11.1468 13.275L10.1433 12.2715L7.80635 14.6085L6.88874 13.6908L5.88525 14.6943L7.30461 16.1137Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M7.80635 20.2862L6.88874 19.3686L5.88525 20.3721L7.30461 21.7914C7.43769 21.9245 7.61817 21.9992 7.80635 21.9992C7.99453 21.9992 8.17501 21.9245 8.30809 21.7914L11.1468 18.9527L10.1433 17.9492L7.80635 20.2862Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M7.80635 25.9639L6.88874 25.0463L5.88525 26.0498L7.30461 27.4691C7.43769 27.6022 7.61817 27.6769 7.80635 27.6769C7.99453 27.6769 8.17501 27.6022 8.30809 27.4691L11.1468 24.6304L10.1433 23.627L7.80635 25.9639Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M29.8064 12.0645H12.7742V13.4838H29.8064V12.0645Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M22.7097 14.9023H12.7742V16.3217H22.7097V14.9023Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M29.8064 17.7422H12.7742V19.1615H29.8064V17.7422Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M22.7097 20.5801H12.7742V21.9994H22.7097V20.5801Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M29.8064 23.4199H12.7742V24.8393H29.8064V23.4199Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M22.7097 26.2578H12.7742V27.6772H22.7097V26.2578Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M29.8064 29.0977H12.7742V30.517H29.8064V29.0977Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M22.7097 31.9355H12.7742V33.3549H22.7097V31.9355Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M10.1433 29.3047L8.51603 30.932L6.88874 29.3047L5.88525 30.3082L7.51254 31.9355L5.88525 33.5628L6.88874 34.5662L8.51603 32.9389L10.1433 34.5662L11.1468 33.5628L9.51951 31.9355L11.1468 30.3082L10.1433 29.3047Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M29.8065 36.9023H22.7097V38.3217H29.8065V36.9023Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBar5);
export default __webpack_public_path__ + "static/media/bar5.4965f7bc91a45aa158e0375feda0c0d0.svg";
export { ForwardRef as ReactComponent };